<div class="custom-control custom-switch" [class.disabled]="isDisabled">
  <input [disabled]="isDisabled" type="checkbox" class="custom-control-input" [id]="elementId" [(ngModel)]="value" (blur)="onBlur()">
  <label class="custom-control-label" [for]="elementId">{{label}}</label>
</div>